import React, { useEffect, useState } from "react";
import Spinner from "react-bootstrap/Spinner";
import { Link, useHistory, withRouter } from "react-router-dom";
import { useDispatch } from "react-redux";
const QuotesComp = (props) => {
	const { id } = props;
	const [data, setData] = useState([]);
	const [loading, setLoading] = useState(true);
	const [apiUrl, setApiUrl] = useState(`/api/v2/customers/${id}/custom_quotes`);
	const [pagination, setPagination] = useState(null);
	const [currentPage, setCurrentPage] = useState();

	const dispatch = useDispatch();
	let history = useHistory();

	useEffect(() => {
		setLoading(true);
		fetch(apiUrl)
			.then((res) => res.json())
			.then((data) => {
				setData(data.data);
				setPagination(data.pagy);
				setCurrentPage(data.pagy.page);
				setLoading(false);
			})
			.catch((err) => console.log(err));
	}, [apiUrl]);

	const viewPolicy = (results) => {
		dispatch({
			type: "SET_INITIAL_QUOTE_DATA",
			payload: results,
		});
		dispatch({
			type: "SET_RENEWAL_ID",
			payload: _.get(results, "quote_hash_id", ""),
		});
		history.push(`/admin/quote-builder/build`);
	};

	return (
		<>
			{loading ? (
				<div className="d-flex justify-content-center my-4">
					<Spinner animation="border" variant="primary" />
				</div>
			) : (
				<div className="col-12">
					{data.map((quote) => {
						return (
							<div className="card otmt-1 col">
								<div className="card-body otmt-1">
									<div className="col-12 d-flex">
										<div className="col-md-6 px-0">
											<div className="">
												<div className="otmb-2">
													<h2 className="">Quote #{quote.id}</h2>
													<p className="mb-1">Created {quote.policy_start}</p>
												</div>
											</div>
										</div>
										<div className="col-6">
											<div className="d-md-flex justify-content-end">
												<button
													className="btn btn-lg btn2"
													onClick={() => viewPolicy(quote)}
												>
													Go To Quote
												</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						);
					})}
				</div>
			)}
			{pagination && (
				<nav aria-label="Page navigation example">
					<ul className="pagination pagination-lg justify-content-center">
						<li
							className={"page-item" + `${pagination.prev ? "" : " disabled"}`}
						>
							<a
								className="page-link"
								href="#"
								tabIndex="-1"
								onClick={() => setApiUrl(pagination.prev_url)}
							>
								Previous
							</a>
						</li>
						{pagination.series.map((item, i) => (
							<li className="page-item" key={i}>
								<a
									className="page-link"
									href="#"
									onClick={() => setApiUrl("/api/v2/quotes?page=" + (i + 1))}
								>
									{item}
								</a>
							</li>
						))}
						<li
							className={"page-item" + `${pagination.next ? "" : " disabled"}`}
						>
							<a
								className="page-link"
								href="#"
								onClick={() => setApiUrl(pagination.next_url)}
							>
								Next
							</a>
						</li>
					</ul>
				</nav>
			)}
		</>
	);
};

export default QuotesComp;
